<ul class="checkboxList">
  <li *ngFor="let selectItem of options">
    <label>
      <input id="reason-{{ selectItem.value.id }}" name="reason-{{ selectItem.value.id }}"
        type="checkbox"
        [(ngModel)]="selectItem.selected"
        (change)="selectionChanged()" />
      {{ selectItem.value.name }}
    </label>
  </li>
  <li class="customReasonRow">
    <div class="customReasonRow-label">
      <label>
        <input id="customRegistrationReasonCheckbox"
          type="checkbox"
          [(ngModel)]="customReasonSelected"
          (change)="customReasonSelectionChanged()" />
        {{ 'registrationReasonAnswer_custom' | l10n }}
      </label>
    </div>
    <div class="customReasonRow-value">
      <input [hidden]="!customReasonSelected"
        #customReasonInput
        type="text"
        class="form-control"
        [(ngModel)]="customReason"
        maxlength="160"
        placeholder="{{ 'registrationReasonAnswer_custom_placeholder' | l10n }}"
        (change)="selectionChanged()" >
    </div>
  </li>
</ul>